<template>
    <f7-page
        name="Partners"
        class="onboardingBg"
    >
        <f7-navbar
            large
            title-large="My Partner"
            large-transparent
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>My Partner</f7-nav-title>
        </f7-navbar>
        <f7-block>Adding your partner to Coral is fun! Learn about each other, do exercises together and a lot more coming soon!</f7-block>

        <f7-block>Coral is FREE for your partner as long as you have a subscription.</f7-block>
        <f7-list>
            <template v-for="(partner, index) in partners">
                <f7-list-item
                    v-if="partner.partnerId || partner.userId === user.id"
                    :title="partner.partnerId ? partner.name : partner.invitationAddress"
                    :key="`partner-${index}`"
                    :after="renderStatus(partner)"
                    @click="removePartner(partner)"
                />
            </template>
        </f7-list>
        <f7-block v-if="canInvite">
            <div class="maxWidth">
                <f7-button
                    fill
                    round
                    href="/addPartner"
                >Invite your partner</f7-button>
            </div>
        </f7-block>
        <f7-list>
            <f7-list-item link="/help">Help</f7-list-item>
        </f7-list>
    </f7-page>
</template>

<script>
export default {
    store: ['api', 'text', 'user', 'partners'],
    data () {
        return {
        };
    },
    computed: {
        canInvite: function () {
            let can = true;
            for (let i = 0; i < this.partners.length; i++) {
                const partner = this.partners[i];
                if (partner.accepted) can = false;
                if (!partner.partnerId && partner.userId === this.user.id) can = false;
            }
            return can;
        }
    },
    created: function () {
        this.$events.fire('partners-get');
    },
    mounted: function () { },
    methods: {
        renderStatus: function (partner) {
            if (!partner.partnerId) {
                return 'Invited';
            }
            return 'Linked';
        },
        removePartner: function (partner) {
            f7.dialog.confirm(partner.accepted ? 'Need some space? Unlink from your partner' : 'Are you sure you don\'t want to invite your partner to Coral?', () => {
                this.$http.delete(`${this.api}/partners/${partner.id}`).then(
                    () => {
                        this.user.hasPartner = false;
                        this.partners = [];
                        this.$events.fire('partners-get');
                        f7.dialog.alert('Partner has been unlinked.');
                    },
                    response => {
                        f7.dialog.alert(response.body.message || 'Unknown error');
                    }
                );
            })
        },
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.block-title {
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
    color: black;
    font-weight: bold;
}
.list.inset {
    border: 3px solid @black;
    border-radius: 0px;
}
.center {
    text-align: center;
}
</style>
